module.exports = __webpack_public_path__ + "img/sen_sound.73b31a32.png";